var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMhcSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 17685",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.292,
    height: 30.305,
    viewBox: "0 0 30.292 30.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12830",
    d: "m2026.727 1163.558 2.706-2.7 4.239 4.342 1.9 2.08v1.059l-.6 1-1.306.361-1.528-.658-3.334-3.541z",
    transform: "translate(-2005.82 -1139.881)",
    style: {
      fill: "#ea5d6e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": 751463
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12826",
    d: "M11.314-511.69a11.814 11.814 0 0 0-7.347 3.46 11.871 11.871 0 0 0-3.36 6.547 15.365 15.365 0 0 0 0 3.614 11.871 11.871 0 0 0 3.36 6.547 11.871 11.871 0 0 0 6.547 3.36 15.37 15.37 0 0 0 3.614 0 12.152 12.152 0 0 0 4.343-1.6l.379-.237 4.094 4.094c4.42 4.408 4.32 4.32 5.1 4.462a2.351 2.351 0 0 0 2.708-2.708c-.142-.782-.053-.681-4.462-5.1l-4.09-4.095.237-.379a12.151 12.151 0 0 0 1.6-4.343 15.364 15.364 0 0 0 0-3.614 11.871 11.871 0 0 0-3.36-6.547 11.775 11.775 0 0 0-6.518-3.348 18.792 18.792 0 0 0-2.845-.113zm2.554 1.268a10.686 10.686 0 0 1 8.787 7.969 10 10 0 0 1 .308 2.269 10.626 10.626 0 0 1-3.561 8.26 10.587 10.587 0 0 1-9.658 2.382A10.477 10.477 0 0 1 4.8-492.35a10.659 10.659 0 0 1-3.028-6.014 16.09 16.09 0 0 1 0-3.022A10.659 10.659 0 0 1 4.8-507.4a10.581 10.581 0 0 1 6.725-3.1 16.772 16.772 0 0 1 2.342.078zm8.491 18.9.824.83-.409.433c-.225.243-.6.622-.841.847l-.433.409-.835-.835-.83-.835.818-.83c.456-.456.835-.836.853-.836s.402.362.852.812zm7.075 7.14a.866.866 0 0 1 .16.628.9.9 0 0 1-.148.61 1.221 1.221 0 0 1-1.363.515c-.243-.065-.533-.338-3-2.8l-2.732-2.726.835-.847.841-.847 2.625 2.619c1.436 1.43 2.692 2.719 2.781 2.843z",
    transform: "translate(-.5 511.709)",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12827",
    d: "M48.725-471.814a9.521 9.521 0 0 0-5.706 2.732 9.424 9.424 0 0 0-2.275 9.712 9.383 9.383 0 0 0 2.275 3.668 9.424 9.424 0 0 0 9.712 2.275A9.383 9.383 0 0 0 56.4-455.7a9.424 9.424 0 0 0 2.275-9.712 9.442 9.442 0 0 0-5.943-5.943 9.342 9.342 0 0 0-4.007-.459zM50.8-470.6a8.064 8.064 0 0 1 4.752 2.364 8.2 8.2 0 0 1 0 11.685 8.2 8.2 0 0 1-11.685 0 8.2 8.2 0 0 1 0-11.685A8.151 8.151 0 0 1 50.8-470.6z",
    transform: "translate(-37.887 474.226)",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12828",
    d: "M190.379-431.609a.719.719 0 0 0-.379.545.665.665 0 0 0 .492.551c.107.018.45.059.764.089a5.992 5.992 0 0 1 4.3 2.643c.071.1.243.421.391.711a3.191 3.191 0 0 0 .379.628.561.561 0 0 0 .877-.2c.1-.249.047-.48-.255-1.078a7.117 7.117 0 0 0-5.908-3.911 2.448 2.448 0 0 0-.661.022z",
    transform: "translate(-178.772 436.385)",
    style: {
      fill: "#ea5d6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12829",
    d: "M300.379-321.817a.7.7 0 0 0-.379.539.678.678 0 0 0 .539.563.4.4 0 0 0 .415-.142.456.456 0 0 0 .2-.427.448.448 0 0 0-.2-.421.486.486 0 0 0-.575-.112z",
    transform: "translate(-282.254 333.117)",
    style: {
      fill: "#ea5d6e"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhcSearchIcon);
export default __webpack_public_path__ + "static/media/mhc-search-icon.f2c41e8e25c42c662fe10e2d6f19c01e.svg";
export { ForwardRef as ReactComponent };